import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { TravelBoardLayout } from "../../components/travel-board/layout";
import { LEGACY_TABS, legacyJourneysSearch } from "../../components/travel-board/legacy-url";
import { canSeeTravel } from "../../lib/travel/access";

/**
 * Arrival & Departure (M9b, PLAN §3) — the layout: the tab row over the
 * page (Overview · Journeys · Entry points), a bare outlet on a journey's
 * own page.
 *
 * `tab` is the OLD page's (`?tab=arrivals|departures`, bookmarks and shared
 * links): it redirects to the Journeys list with the old filters carried
 * (`legacyJourneysSearch`). The carried keys are read off the raw URL, so the
 * layout's own search stays `games_id` (+ the legacy `tab`).
 *
 * Who: admins, or a group with `logistics.travel` / `logistics.travel_review`.
 * A courtesy, not the control — the API scopes every row in SQL.
 */
export const Route = createFileRoute("/_app/logistics/arrival-departure")({
	validateSearch: z.object({
		games_id: z.string().uuid().optional().catch(undefined),
		tab: z.enum(LEGACY_TABS).optional().catch(undefined),
	}),
	beforeLoad: ({ context, search, location }) => {
		if (!canSeeTravel(context.session)) throw redirect({ to: "/" });
		const legacy = legacyJourneysSearch(search.tab, location.search as Record<string, unknown>);
		if (legacy) throw redirect({ to: "/logistics/arrival-departure/journeys", search: legacy, replace: true });
	},
	staticData: { contentTop: "tabbed" },
	component: ArrivalDepartureLayout,
});

function ArrivalDepartureLayout() {
	const { session } = Route.useRouteContext();
	return <TravelBoardLayout session={session} />;
}
